function debounce(func, delay) {
  let timeoutId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

class CartItem extends HTMLElement {
    constructor() {
      super();
      this.productQuanityField = this.querySelector("input.quantity__input");
      this.productPlusButton = this.querySelector("button.quantity__button.quantity-plus");
      this.productMinusButton = this.querySelector("button.quantity__button.quantity-minus");
      this.removeButton = this.querySelector('.cart-item-remove');
      this.delayedIncreasedQuantity = debounce(this.incrementQuantity.bind(this), 500);
      this.delayedDecreaseQuantity = debounce(this.decrementQuantity.bind(this), 500);
      this.productPlusButton?.addEventListener("click",(e)=> this.delayedIncreasedQuantity(e));
      this.productMinusButton?.addEventListener("click",(e) =>  this.delayedDecreaseQuantity(e));
      this.productQuanityField?.addEventListener("change", this.validateQuantity.bind(this));
      this.removeButton.addEventListener('click', this.removeCartItem.bind(this));
    }
    removeCartItem(e) {
      e.preventDefault();
      this.removeButton.classList.add('loading');
      const key = this.getAttribute('data-key');
      this.style.opacity = 0.3
      const formData = {
        'id': key,
        "quantity": 0
      };
      this.changeCart(formData);
    }
    validateQuantity(e){
      e.preventDefault();
      const key = this.getAttribute('data-key');
      const formData = {
        'id': key,
        "quantity": Number(this.productQuanityField.value)
      };
      this.changeCart(formData);
    }
    
  
    incrementQuantity(e) {
      e.preventDefault();
      let current = Number(this.productQuanityField.value);
      let max= Number(this.productQuanityField.getAttribute('max'));
      let newval = (current + 1);
      if(max && newval > max) newval = max;
      this.productQuanityField.value = Number(newval);
      const key = this.getAttribute('data-key');
      const formData = {
        'id': key,
        "quantity": Number(newval)
      };
      this.changeCart(formData);
      e.preventDefault();
    }
    decrementQuantity(e) {
      let current = Number(this.productQuanityField.value);
      let newval = (current - 1);
      this.productQuanityField.value = Number(newval);
      const key = this.getAttribute('data-key');
      const formData = {
        'id': key,
        "quantity": Number(newval)
      };
      this.changeCart(formData);
      e.preventDefault();
    }
    changeCart(formData){
      const domParser = new DOMParser(); 
      this.style.opacity = 0.3;
      this.removeButton.classList.add('loading');
      this.style.pointerEvents = 'none';
      const itemKey = this.getAttribute('data-key');
      let cartItem = this;
      fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      }).then(function (data) {
        return data.json()
      })
      .then((data)=>{ 
            const url = document.querySelector('.section-mini-cart').id.replace('shopify-section-','');
            fetch(`${Shopify.routes.root}?section_id=${url}`)
            .then(res=>res.text())
            .then(html=>{
                  const cartHtml = domParser.parseFromString(html, 'text/html');
                  const footerCart = cartHtml.querySelector(`.section-mini-cart .total-calculations`);
                  const itemsList = cartHtml.querySelector(`.section-mini-cart .cart-items-list`);
                  const itemsCount = cartHtml.querySelectorAll(`.section-mini-cart cart-item`);
                  if(itemsCount.length > 0){
                    document.querySelector(`.section-mini-cart .total-calculations`).innerHTML = footerCart.innerHTML;
                    document.querySelector(`.section-mini-cart div.min-cart-footer`).style.display="flex"
                    document.querySelector('.mini-cart-bubble').textContent = itemsList.getAttribute('data-count');
                    const quickAddWrapper = document.querySelector('.quick-view-wrap');
                    const quickAddOverlay = document.querySelector('.quick-view-overlay');
                    if(quickAddWrapper) quickAddWrapper.classList.remove('visible');
                    if(quickAddOverlay) quickAddOverlay.classList.remove('visible');
                    document.documentElement.style.overflow = 'auto';
                    this.removeButton.classList.remove('loading');
                  }
                  else{
                    document.querySelector(`.section-mini-cart div.min-cart-footer`).style.display="none"
                    document.querySelector('.mini-cart-bubble').textContent = '0'
                  }
                  const htmlCard =cartHtml.querySelector(`.section-mini-cart .cart-items-list`);
                  document.querySelector(`.section-mini-cart .cart-items-list`).innerHTML = htmlCard.innerHTML;
                  if(data.status === 422) {
                    const errorElement = document.createElement('div');
                    errorElement.classList.add('error-message');
                    errorElement.innerHTML = data.message;
                    document.querySelector(`[data-key="${ itemKey }"] .cart-item-details`).appendChild(errorElement);
                    return;
                  }

            })
       })
      .catch((error)=>{
        this.removeButton.classList.remove('loading');
        console.error('Request failed', error)
      });
    }
  }
customElements.define('cart-item', CartItem);

const deskcartButton = document.querySelector('.header-icon-cart');
const mobcartButton = document.querySelector('.mobile-drawer-cart');
const cartCloseButton = document.querySelector('.cart__close');
[deskcartButton,mobcartButton].forEach(cartButton=>{
(cartButton && cartButton.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.mini-cart').classList.add('is-open');
    document.querySelector('.mini-cart + .drawer-overlay').classList.add('is-open');
    document.documentElement.style.overflow="hidden"
}));})


